import { FormattedMessage } from 'react-intl';

import { FullWidthContainer } from 'atoms/layout/FullWidthContainer';
import { Vertical } from 'atoms/layout/flex';
import { HeadlineS } from 'atoms/typography';

import { Transfer, Props as TransferProps } from './Transfer';

type Props = {
  club: {
    displayName: string;
    slug: string;
    pictureUrl: string | null;
    code: string | null;
  };
  transfers: TransferProps['transfer'][];
};

export const Transfers = ({ club, transfers }: Props) => {
  return (
    <FullWidthContainer>
      <Vertical gap={1.5}>
        <HeadlineS as="h2">
          <FormattedMessage
            id="Seo.Team.Transfer.teamTransfers"
            defaultMessage="{team} transfers"
            values={{ team: club.displayName }}
          />
        </HeadlineS>
        {transfers.map(transfer => (
          <Transfer key={transfer.id} transfer={transfer} club={club} />
        ))}
      </Vertical>
    </FullWidthContainer>
  );
};
